import MarkdownIt from 'markdown-it'

export function markdownToHtml(md) {
  const markdownInstance = new MarkdownIt({ linkify: true, breaks: true })
  const html = markdownInstance.render(md)

  return html.replace(/<a href=/gi, '<a target="_blank" href=')
}
